import TableTemplate, {
  IFilterTableCols,
} from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { getAccountPortfoTable } from "../../../Requests/deltaHedgeAccounts";
import { IDeltaHedgeAccountDetailReportSearchParam } from "../../../Interfaces/deltaHedgeAccounts";

interface IProps {
  searchParams: IDeltaHedgeAccountDetailReportSearchParam;
  filterCols: IFilterTableCols;
}

const AccountPortfoTable = ({ searchParams, filterCols }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports }) => (
        <CommonTableUI reports={reports} filterCols={filterCols} />
      )}
      getDataTable={getAccountPortfoTable}
      searchParameters={searchParams}
      refreshTableTime={10000}
    />
  );
};

export default AccountPortfoTable;
